import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { Select } from "@caelor/ui";
import useCosmosCollections from "../../../../../../hooks/use-cosmos-collections";
import { useWorkAnniversaryStore } from "../../../../../../stores/use-work-anniversary-store";

function ContentSettings() {
  const { t } = useTranslation();

  const { data, updateData } = useWorkAnniversaryStore((state) => ({
    data: state.data,
    updateData: state.updateData,
  }));

  const { collections } = useCosmosCollections();

  return (
    <>
      <SettingsOptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("collections")}</OptionLabel>
          <OptionContent full>
            <Select
              placeholder={t("select-collections")}
              value={collections.filter((collection) =>
                data?.collectionId?.includes(collection.value)
              )}
              options={collections}
              isMulti
              onChange={(result) =>
                updateData({
                  value: {
                    collectionId: result.map((c) => c.value),
                  },
                })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default ContentSettings;
